<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>
  #app{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue